<script>
import i18n from '@/helpers/i18n'

import simplebar from 'simplebar-vue'
import { layoutComputed, authComputed } from '@/state/helpers'
import FullscreenBtn from '../shared/fullscreen-btn'
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    }
  },
  computed: {
    ...layoutComputed,
    ...authComputed
  },
  components: {},
  data () {
    // TODO - remove language bar
    return {
      current_language: i18n.locale
    }
  },
  mounted () {},
  methods: {
    toggleRightSidebar () {
      this.$parent.toggleRightSidebar()
    },
    toggleMenu () {
      let element = document.getElementById('topnav-menu-content')
      element.classList.toggle('show')
    }
  },
  watch: {
    type: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'dark':
              document.body.setAttribute('data-topbar', 'dark')
              break
            case 'light':
              document.body.setAttribute('data-topbar', 'light')
              document.body.removeAttribute('data-layout-size', 'boxed')
              break
            case 'colored':
              document.body.setAttribute('data-topbar', 'colored')
              document.body.removeAttribute('data-layout-size', 'boxed')
              break
            default:
              document.body.setAttribute('data-topbar', 'dark')
              break
          }
        }
      }
    },
    width: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'boxed':
              document.body.setAttribute('data-layout-size', 'boxed')
              break
            case 'fluid':
              document.body.setAttribute('data-layout-mode', 'fluid')
              document.body.removeAttribute('data-layout-size')
              break
            default:
              document.body.setAttribute('data-layout-mode', 'fluid')
              break
          }
        }
      }
    }
  }
}
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex align-items-center">
        <!-- LOGO -->
        <div class="navbar-brand-box p-0">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                src="@/assets/images/logo.svg"
                alt
                height="22"
                class="ml-2"
              />
            </span>
            <span class="logo-lg">
              <img
                src="@/assets/images/logo-dark.png"
                alt
                height="17"
                class="ml-2"
              />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                src="@/assets/images/logo_oms.svg"
                alt
                height="30"
                class="ml-2"
              />
            </span>
            <span class="logo-lg">
              <div class="d-flex align-items-end justify-content-between">
                <img
                  src="@/assets/images/logo_oms.svg"
                  alt
                  height="40"
                  class="ml-3 mr-2"
                />
                <p
                  class="m-0 p-0 font-size-16 font-weight-bold text-light text-uppercase"
                  style="line-height: 16px; text-align: left"
                >
                  OMS bv<br />
                  <small class="font-weight-light font-size-11 text-muted"
                    >Customer Portal</small
                  >
                </p>
              </div>
            </span>
          </router-link>
        </div>

        <button
          id="toggle"
          type="button"
          class="btn btn-sm mr-2 font-size-16 d-lg-none header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <b-btn
          variant="black"
          class="noti-icon"
          v-if="userProfile.preferences.allow_products"
        >
          <i class="bx bx-box mr-2"></i>
          <span class="text-light">{{ $t('PRODUCTS') }}</span>
        </b-btn>

        <app-quick-add-form-btn class="mr-1" />
        <app-cart-btn />

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="ml-1"
        >
          <template v-slot:button-content>
            <b-avatar size="30" variant="secondary" class="mx-2" v-if="true">
              <i class="bx bx-user"></i>
            </b-avatar>
            <span class="d-none d-xl-inline-block ml-1">{{
              userProfile.name
            }}</span>
            <i class="mdi mdi-chevron-down ml-1 d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link tag="span" :to="{ name: 'account' }">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              {{ $t('profile') }}
            </router-link>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"
            ></i>
            {{ $t('logout') }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
